import React, { useEffect, useState } from "react";
import { Card, CardContent, Grid, Typography, Link } from "@material-ui/core";
import Alert from "@material-ui/lab/Alert";
import { useTranslation } from 'react-i18next';

import useStyles from "./Home.style";
import { Link as RouterLink } from "react-router-dom";
import Cookies from 'universal-cookie';


const cookies = new Cookies();

const Home = () => {
    const classes = useStyles();
    const { t } = useTranslation();

    const [dashboardData, setDashboardData] = useState();
    const [error, setError] = useState('');

    useEffect(() => {
        const getDashboardData = async () => {
            try {
                let response = await fetch(`${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_API_PROVIDER_DASHBOARD}`, {
                    headers: {
                        'X-ACCESS-TOKEN': cookies.get('token')
                    }
                });
                let json = await response.json();
                if (!response.ok) {
                    setError(t('module.provider.dashboard.message.providerDataLoadFailure'));
                    return;
                };
                setDashboardData(json);
            } catch (error) {
                console.log(error);
                setError(`${t('module.provider.dashboard.message.dataLoadError')}. ${t('common.message.error.seeLog')}.`);
            }
        };

        getDashboardData();
    }, [t]);

    if (error) return <Alert severity="error">{error}</Alert>

    return (
        <Grid container>
            <Grid item xl={2} md={3} sm={6} xs={12}>
                {dashboardData &&
                    <Link component={RouterLink} to="/provider/provider/mypatients">
                        <Card className={classes.panel}>
                            <CardContent>
                                <Grid container>
                                    <Grid item xs={6} className={classes.panelNumber}>
                                        <Typography variant="h2">{dashboardData.qtyAssociatedPatients}</Typography>
                                    </Grid>
                                    <Grid item xs={6} className={classes.panelText}>
                                        <Typography variant="h5" color="textSecondary">
                                            {t('module.provider.dashboard.text.patientsRelated')}
                                        </Typography>
                                    </Grid>
                                </Grid>
                            </CardContent>
                        </Card>
                    </Link>
                }
            </Grid>
        </Grid>
    )
};

export default Home;